module.exports = __webpack_public_path__ + "img/pic_1_zh.82a70634.png";